import React, { Fragment, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import style from "../../../scss/TablaDatos.module.scss";
import ModalconteoComponent from "./ModalconteoComponent";
import AlertComponent from "../../../components/AlertComponent";
import { AccionesTabla, BotonEditar, BotonEliminar } from "../../../components/BotonIconoComponent";
import Swal from "sweetalert2";
import { eliminarvotos } from "../../../Api/ApiConteo";
import { etiquetaTipoCandidato } from "../../../constants/tiposCandidato";
import { rutaEscrutinio } from "../../../utils/problemasMesa";

const formatoVotos = (valor) => Number(valor).toLocaleString("es-CO");

// orden de lectura: lugar, número de mesa y de mayor a menor votación
const ordenarConteo = (datos) =>
  [...datos].sort(
    (a, b) =>
      a.lugar.localeCompare(b.lugar) ||
      Number(a.mesa) - Number(b.mesa) ||
      Number(b.votos) - Number(a.votos)
  );
const TablaConteo = (props) => {
  const [show, setShow] = useState(false);
  const {
    datos,
    setconteo,
    onCambio,
    opcionesCandidato,
    opcionesLugar,
    opcionesMesaDe,
  } = props;

  const [selectedOptionlugar, setSelectedOptionlugar] = useState(null);
  const [selectedOptionmesa, setSelectedOptionmesa] = useState(null);
  const [selectecandidato, setSelectecandidato] = useState(null);
  const [Votos, setVotos] = useState();
  const [id, setId] = useState("");
  const [mostraralert, setMostraralert] = useState(false);
  const [colorAlert, setcolorAlert] = useState("");
  const [alerta, setAlerta] = useState("");
  const filas = useMemo(() => ordenarConteo(datos), [datos]);
  const totalVotos = filas.reduce((suma, item) => suma + Number(item.votos), 0);

  const handleShow = (editar) => {
    setId(editar.id);
    setSelectecandidato(editar.candidatoId);
    setSelectedOptionlugar(editar.lugar);
    setSelectedOptionmesa(editar.mesa);
    setVotos(editar.votos);
  };

  const eliminarR = (id) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Una vez eliminado, no podrás recuperar este registro: .",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, Confirmar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        // Si el usuario confirma la eliminación, realiza la lógica de eliminación aquí
        eliminarvotos(id)
          .then((response) => {
            Swal.fire({
              icon: "success",
              title: "Elemento eliminado",
              text: response.msg,
            });
            // refresca la tabla y los totales sin recargar la página
            onCambio?.();
          })

          .catch((error) => console.error(error));
      }
    });
  };

  return (
    <Fragment>
      <div
        className="d-flex justify-content-center"
      >
        <AlertComponent
          mensaje={alerta}
          mostraralert={mostraralert}
          styleGrup={`${colorAlert} text-center  w-50`}
        />
      </div>

      {/* en celular cada fila se muestra como tarjeta (data-label da el título de cada dato) */}
      <div className={style.contenedor}>
        <table className={style.tabla}>
          <thead>
            <tr>
              <th scope="col" className={style.numero}>#</th>
              <th scope="col">Candidato</th>
              <th scope="col">Corporación</th>
              <th scope="col">Lugar</th>
              <th scope="col" className={style.centro}>Mesa</th>
              <th scope="col" className={style.derecha}>Votos</th>
              <th scope="col" className={style.derecha}>
                <span className="visually-hidden">Acciones</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {filas.length === 0 ? (
              <tr className={style.filaVacia}>
                <td colSpan={7}>
                  <Icon icon="mdi:table-search" aria-hidden="true" /> No hay votos registrados con estos filtros.
                </td>
              </tr>
            ) : (
              filas.map((item, index) => (
                <tr key={item.id}>
                  <td className={style.numero} data-label="#">
                    {index + 1}
                  </td>
                  <th scope="row" className={style.candidato} data-label="Candidato">
                    {item.Candidato?.nombre}
                  </th>
                  <td data-label="Corporación">
                    <span className={style.chip}>{etiquetaTipoCandidato(item.Candidato?.tipo)}</span>
                  </td>
                  <td data-label="Lugar">{item.lugar}</td>
                  <td className={style.centro} data-label="Mesa">
                    {item.mesa}
                  </td>
                  <td className={`${style.derecha} ${style.votos}`} data-label="Votos">
                    {formatoVotos(item.votos)}
                  </td>
                  <td className={`${style.derecha} ${style.acciones}`}>
                    {/* los votos de un acta E-14 se corrigen desde su escrutinio */}
                    {item.escrutinioId ? (
                      <Link
                        to={rutaEscrutinio({ corporacion: item.Candidato?.tipo, lugar: item.lugar, mesa: item.mesa })}
                        className={style.verActa}
                        title={`Abrir el acta E-14 de ${item.lugar}, mesa ${item.mesa}`}
                      >
                        <Icon icon="mdi:file-document-outline" aria-hidden="true" /> Ver acta
                      </Link>
                    ) : (
                      <AccionesTabla>
                        <BotonEditar
                          etiqueta={`Editar votos de ${item.Candidato?.nombre}`}
                          onClick={() => {
                            handleShow(item);
                            setShow(true);
                          }}
                        />
                        <BotonEliminar
                          etiqueta={`Eliminar votos de ${item.Candidato?.nombre}`}
                          onClick={() => eliminarR(item.id)}
                        />
                      </AccionesTabla>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
          {filas.length > 0 && (
            <tfoot>
              <tr>
                <th scope="row" colSpan={5}>
                  Total ({filas.length} {filas.length === 1 ? "registro" : "registros"})
                </th>
                <td className={`${style.derecha} ${style.votos}`} data-label="Total votos">
                  {formatoVotos(totalVotos)}
                </td>
                <td aria-hidden="true" />
              </tr>
            </tfoot>
          )}
        </table>
      </div>
      <ModalconteoComponent
        setShow={setShow}
        show={show}
        id={id}
        setId={setId}
        setSelectedOptionlugar={setSelectedOptionlugar}
        setSelectedOptionmesa={setSelectedOptionmesa}
        setSelectecandidato={setSelectecandidato}
        setVotos={setVotos}
        selectedOptionlugar={selectedOptionlugar}
        selectedOptionmesa={selectedOptionmesa}
        candidato={selectecandidato}
        votos={Votos}
        setcolorAlert={setcolorAlert}
        setAlerta={setAlerta}
        datos={datos}
        setconteo={setconteo}
        setMostraralert={setMostraralert}
        opcionesCandidato={opcionesCandidato}
        opcionesLugar={opcionesLugar}
        opcionesMesaDe={opcionesMesaDe}
        onCambio={onCambio}
      />
    </Fragment>
  );
};
export default TablaConteo;
